const translations = {
    refresh: 'Refresh'
};

export default translations;
